export const WavePattern = ({ className = '', opacity = 0.15 }) => (
  <svg className={`absolute pointer-events-none ${className}`} viewBox="0 0 1400 900" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
    <defs>
      <linearGradient id="waveGrad" x1="0%" y1="0%" x2="80%" y2="100%">
        <stop offset="0%" stopColor="#00CED1" stopOpacity="0.1" />
        <stop offset="40%" stopColor="#00CED1" stopOpacity="0.6" />
        <stop offset="70%" stopColor="#06b6d4" stopOpacity="0.8" />
        <stop offset="100%" stopColor="#0891b2" stopOpacity="0.3" />
      </linearGradient>
    </defs>
    {[...Array(12)].map((_, i) => {
      const yStart = 100 + i * 35;
      const curve1 = 200 + i * 20;
      const curve2 = yStart + 150 + Math.sin(i) * 80;
      const xEnd = 900 + i * 40;
      const yEnd = 700 + i * 15;
      return (
        <path
          key={i}
          d={`M${800 + i * 30} ${yStart - 100} Q${xEnd} ${curve1} ${1100 + i * 15} ${curve2} T${xEnd - 200} ${yEnd} Q${600 - i * 20} ${yEnd + 50} ${400 - i * 30} ${yEnd + 100}`}
          stroke="url(#waveGrad)"
          strokeWidth={1.2 - i * 0.05}
          fill="none"
          opacity={opacity - i * 0.008}
          style={{ animationDelay: `${i * 0.15}s` }}
        />
      );
    })}
  </svg>
);
